import React from 'react';
import { ContextLayout } from '../../context-provider';
export default function IconArrowDown(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$useCurrentColo = props.useCurrentColor,
      useCurrentColor = _props$useCurrentColo === void 0 ? true : _props$useCurrentColo,
      style = props.style;
  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement("svg", {
      className: prefixCls + "-icon " + prefixCls + "-icon-arrow-down " + className,
      width: "1em",
      height: "1em",
      style: style,
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      fill: useCurrentColor ? "currentColor" : "#000000",
      d: "M512 676.864l346.944-346.965a21.333 21.333 0 0130.187 0l30.165 30.186a21.333 21.333 0 010 30.166L542.166 767.36a42.667 42.667 0 01-60.331 0L104.704 390.25a21.333 21.333 0 010-30.165l30.165-30.186a21.333 21.333 0 0130.187 0L512 676.864z"
    }));
  });
}